import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import Authenticator from './action_panel/Authenticator';
import RevokeOTPToken from './action_panel/RevokeOTPToken';
import Password from './action_panel/Password';
import Mobile from './action_panel/Mobile';
import Email from './action_panel/Email';
import Realinfo from './action_panel/Realinfo';
import VerifyEmail from './action_panel/VerifyEmail';
import Facebook from './action_panel/Facebook'
import GameOTP from './action_panel/GameOTP'
import { COUNTRY_NEED_REVOKE_TOKEN, COUNTRY_NEED_REAL_INFO, COUNTRY_NEED_FACEBOOK_CONNECT, COUNTRY_NEED_GAME_OTP } from '../../constants';

class ActionPanel extends React.Component {
	render() {
		return (
			<div className="aside-nav">
				<Authenticator />
				<Password />
				<Mobile />
				{!this.props.userInfo.email_v ? <Email /> : null}
				{(this.props.userInfo.email && !this.props.userInfo.email_v) ? <VerifyEmail /> : null}
				{this.props.language&&COUNTRY_NEED_REAL_INFO.indexOf(this.props.language.country)>=0&&!this.props.userInfo.realname ? <Realinfo /> : null}
				{this.props.language&&COUNTRY_NEED_REVOKE_TOKEN.indexOf(this.props.language.country)>=0&&this.props.userInfo.two_step_verify_enable? <RevokeOTPToken /> : null}
				{this.props.language&&COUNTRY_NEED_FACEBOOK_CONNECT.indexOf(this.props.language.country)>=0&&(this.props.userInfo.fb_account!=null||this.props.userInfo.is_fbconnect_enabled)?<Facebook />: null}
				{this.props.language&&COUNTRY_NEED_GAME_OTP.indexOf(this.props.language.country)>=0?<GameOTP />: null}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		language: state.data.language
	}
}

export default connect(mapStateToProps)(ActionPanel);



// WEBPACK FOOTER //
// ./app/components/security/ActionPanel.js